import { render, staticRenderFns } from "./Game1-7.vue?vue&type=template&id=71e4f777&scoped=true&"
import script from "./Game1-7.vue?vue&type=script&lang=js&"
export * from "./Game1-7.vue?vue&type=script&lang=js&"
import style0 from "./Game1-7.vue?vue&type=style&index=0&id=71e4f777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4f777",
  null
  
)

export default component.exports